var $844be78af2d57459$exports = {};
$844be78af2d57459$exports = {
    "loading": `Notiek iel\u{101}de...`,
    "placeholder": `Izv\u{113}l\u{113}ties\u{2026}`
};


export {$844be78af2d57459$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
